/* Carrousel de vidéos (accueil) */
(function () {
  'use strict';

  var reduceMotion = false;
  try { reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) {}

  function init(root) {
    if (!root || root.getAttribute('data-reels-ready') === '1') return;
    var track = root.querySelector('[data-reels-track]');
    if (!track) return;
    root.setAttribute('data-reels-ready', '1');

    var cards = [].slice.call(track.querySelectorAll('[data-reel]'));
    var prevBtn = root.querySelector('[data-reels-prev]');
    var nextBtn = root.querySelector('[data-reels-next]');
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    var wantSound = false;
    var inView = true;
    var active = -1;
    var raf = 0;

    function videoOf(card) { return card ? card.querySelector('[data-reel-video]') : null; }

    function syncButtons(card) {
      var v = videoOf(card);
      if (!v) return;
      var t = card.querySelector('[data-reel-toggle]');
      if (t) {
        var paused = v.paused;
        t.setAttribute('data-state', paused ? 'paused' : 'playing');
        t.setAttribute('aria-label', paused ? 'Lancer la vidéo' : 'Mettre la vidéo en pause');
      }
      var s = card.querySelector('[data-reel-sound]');
      if (s) {
        var on = !v.muted;
        s.setAttribute('aria-pressed', on ? 'true' : 'false');
        s.setAttribute('aria-label', on ? 'Couper le son' : 'Activer le son');
      }
    }

    function tryPlay(v, card) {
      if (!v) return;
      var p;
      try { p = v.play(); } catch (e) { p = null; }
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          /* le navigateur refuse le son sans geste : on relance sans le son */
          if (!v.muted) {
            v.muted = true;
            try {
              var q = v.play();
              if (q && typeof q.catch === 'function') q.catch(function () {});
            } catch (e2) {}
          }
          syncButtons(card);
        });
      }
    }

    function warm(card) {
      var v = videoOf(card);
      if (v && v.getAttribute('preload') === 'none') {
        v.setAttribute('preload', 'metadata');
      }
    }

    function setActive(i, force) {
      if (!cards.length) return;
      if (i < 0) i = 0;
      if (i > cards.length - 1) i = cards.length - 1;
      if (i === active && !force) return;
      active = i;
      cards.forEach(function (card, k) {
        var v = videoOf(card);
        var on = k === i;
        card.classList.toggle('is-active', on);
        if (!v) return;
        if (on) {
          v.muted = !wantSound;
          if (autoplay && inView && card.getAttribute('data-user-paused') !== '1') tryPlay(v, card);
        } else {
          v.pause();
          v.muted = true;
        }
        syncButtons(card);
      });
      warm(cards[i - 1]);
      warm(cards[i + 1]);
      if (prevBtn) prevBtn.disabled = i <= 0;
      if (nextBtn) nextBtn.disabled = i >= cards.length - 1;
    }

    function centerIndex() {
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var dist = Infinity;
      cards.forEach(function (card, k) {
        var d = Math.abs(card.offsetLeft + card.offsetWidth / 2 - mid);
        if (d < dist) { dist = d; best = k; }
      });
      return best;
    }

    var isStatic = false;
    function checkStatic() {
      var gap = parseFloat((window.getComputedStyle(track).columnGap || '0')) || 0;
      var total = 0;
      cards.forEach(function (c) { total += c.offsetWidth; });
      total += gap * Math.max(0, cards.length - 1);
      var fits = total <= track.clientWidth + 1;
      if (fits !== isStatic) {
        isStatic = fits;
        root.classList.toggle('is-static', fits);
        if (!fits) scrollToCard(Math.max(0, active), true);
      }
    }

    function goTo(i, instant) {
      if (isStatic) setActive(i); else scrollToCard(i, instant);
    }

    function scrollToCard(i, instant) {
      var card = cards[i];
      if (!card) return;
      var left = card.offsetLeft + card.offsetWidth / 2 - track.clientWidth / 2;
      if (typeof track.scrollTo === 'function') {
        track.scrollTo({ left: left, behavior: (reduceMotion || instant) ? 'auto' : 'smooth' });
      } else {
        track.scrollLeft = left;
      }
    }

    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = 0;
        if (!isStatic) setActive(centerIndex());
      });
    }, { passive: true });

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(Math.max(0, active - 1)); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(Math.min(cards.length - 1, active + 1)); });

    cards.forEach(function (card, k) {
      var v = videoOf(card);
      card.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('a')) return;
        if (e.target.closest && e.target.closest('button')) return;
        if (k !== active) { goTo(k); return; }
        if (!v) return;
        if (v.paused) { card.removeAttribute('data-user-paused'); tryPlay(v, card); }
        else { card.setAttribute('data-user-paused', '1'); v.pause(); }
      });
      if (!v) return;
      var t = card.querySelector('[data-reel-toggle]');
      var s = card.querySelector('[data-reel-sound]');
      if (t) t.addEventListener('click', function () {
        if (v.paused) { card.removeAttribute('data-user-paused'); tryPlay(v, card); }
        else { card.setAttribute('data-user-paused', '1'); v.pause(); }
        syncButtons(card);
      });
      if (s) s.addEventListener('click', function () {
        v.muted = !v.muted;
        wantSound = !v.muted;
        if (v.paused && !v.muted) { card.removeAttribute('data-user-paused'); tryPlay(v, card); }
        syncButtons(card);
      });
      v.addEventListener('play', function () { syncButtons(card); });
      v.addEventListener('pause', function () { syncButtons(card); });
      v.addEventListener('volumechange', function () { syncButtons(card); });
    });

    root.addEventListener('keydown', function (e) {
      var tag = e.target && e.target.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(cards.length - 1, active + 1)); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(0, active - 1)); }
    });

    /* pause quand le carrousel n'est plus à l'écran */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          inView = en.isIntersecting;
          var card = cards[active];
          var v = videoOf(card);
          if (!v) return;
          if (inView) {
            if (autoplay && card.getAttribute('data-user-paused') !== '1') tryPlay(v, card);
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.35 });
      io.observe(root);
    }

    /* pause quand l'onglet est caché */
    document.addEventListener('visibilitychange', function () {
      var card = cards[active];
      var v = videoOf(card);
      if (!v) return;
      if (document.hidden) v.pause();
      else if (autoplay && inView && card.getAttribute('data-user-paused') !== '1') tryPlay(v, card);
    });

    /* éditeur de thème : montrer le bloc sélectionné */
    root.closest('.shopify-section') && root.closest('.shopify-section').addEventListener('shopify:block:select', function (e) {
      var idx = cards.indexOf(e.target);
      if (idx > -1) goTo(idx, true);
    });

    /* départ : première carte au centre */
    checkStatic();
    if (!isStatic) scrollToCard(0, true);
    setActive(0, true);

    var resizeTimer = 0;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        checkStatic();
        if (!isStatic) scrollToCard(Math.max(0, active), true);
      }, 150);
    });
  }

  function initAll() {
    [].slice.call(document.querySelectorAll('[data-samdia-reels]')).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
